import { render } from "./Kunst.vue?vue&type=template&id=51c27b8e&scoped=true"
import script from "./Kunst.vue?vue&type=script&lang=js"
export * from "./Kunst.vue?vue&type=script&lang=js"

import "./Kunst.vue?vue&type=style&index=0&id=51c27b8e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51c27b8e"]])

export default __exports__